import { render, staticRenderFns } from "./Accumulated.vue?vue&type=template&id=76875e80&%3Aelement-loading-text=%24locale('global.loading')&element-loading-spinner=el-icon-loading&"
import script from "./Accumulated.vue?vue&type=script&lang=js&"
export * from "./Accumulated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports